import apiClient from '../common/apiClient';

export default class LoginController {
  async Login(data) {
    try {
      return await apiClient.post('/login', data);
    } catch (error) {
      return error;
    }
  }

  async ForgotPassword(data) {
    try {
      return await apiClient.post('/forgot-password', data);
    } catch (error) {
      return error;
    }
  }
}
